import { Dispatch, SetStateAction } from 'react';

import { Table, withQueryState } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { ISystemUser } from 'system/types';

interface IProps {
  tableColumns;
  users: ISystemUser[];
  isLoading?: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
  setSelectedRows?: Dispatch<SetStateAction<ISystemUser[]>>;
  onCheckboxClick?: () => void;
  isModalOpen?: boolean;
}

const UsersManagerView = ({
  tableColumns,
  users,
  isLoading,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  setSelectedRows,
  onCheckboxClick,
  isModalOpen,
}: IProps) => {
  return (
    <Table
      columns={tableColumns}
      data={users}
      name={TableNames.MANAGE_USERS}
      alternating={false}
      borderBottom={true}
      hasRowSelection={true}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      setSelectedRows={setSelectedRows}
      onCheckboxClick={onCheckboxClick}
      isModalOpen={isModalOpen}
    />
  );
};

export default withQueryState(UsersManagerView);
